import { UPPER_LOWER_CIRCUIT, UPPER_LOWER_CIRCUIT_STREAM, } from "../../../interface/iUpperLowerCircuit";
import { drivingMarketStreamingUpdate, } from "@domains/features/Markets/Equity/utils/streamingUpdate";
let initState = {
    data: [],
};
const upperLowerCircuit = (state = initState, action) => {
    switch (action.type) {
        case UPPER_LOWER_CIRCUIT:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case UPPER_LOWER_CIRCUIT_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketStreamingUpdate(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default upperLowerCircuit;
